// Copyright (c) 2025 by Audere

import { Button } from "@mui/material";
import React from "react";
import { createStyleSheet } from "../utils/styles";
import { useCurrentUser } from "../hooks/useCurrentUser";
import { useTranslation } from "react-i18next";

interface HeaderButtonProps {
  handleEditButtonClick: () => void;
  submitted: boolean;
}

const HeaderButton: React.FC<HeaderButtonProps> = ({
  handleEditButtonClick,
  submitted,
}) => {
  const { isQC, isLabeler, isMonitor, role } = useCurrentUser();
  const { t } = useTranslation();

  if (isMonitor) {
    return (
      <Button
        variant="contained"
        onClick={handleEditButtonClick}
        sx={styles.btn}
        aria-label={"Monitors should only be able to view not edit."}
      >
        {t("form.viewLabels")}
      </Button>
    );
  }
  if (isQC) {
    return (
      <Button
        variant="contained"
        onClick={handleEditButtonClick}
        sx={styles.btn}
        aria-label={"Enter review mode for a labeled conversation"}
      >
        {submitted ? t("form.reviewQC") : t("form.startQC")}
      </Button>
    );
  } else if (isLabeler) {
    return (
      <Button
        variant="contained"
        onClick={handleEditButtonClick}
        sx={styles.btn}
        aria-label={"Enter edit mode for adding labels to a conversation"}
      >
        {submitted ? t("form.viewLabels") : t("form.addLabels")}
      </Button>
    );
  } else {
    console.error("User role is nether labeler or QC: User role: ", role);
  }
};

const styles = createStyleSheet({
  btn: {
    maxHeight: 50,
    marginRight: 3,
  },
});

export default HeaderButton;
